import { Loader } from 'modules/Loader';
import { Switch } from 'modules/Switch';
import { MenuItem } from './MenuItem';
import { IconContainer, SwitchContainer } from './styled';
export function MenuItemSwitch(props) {
    const { children, checked, disabled, loading, onChange, closeOnClick } = props;
    const handleChange = (newChecked) => onChange === null || onChange === void 0 ? void 0 : onChange(newChecked);
    const handleSwitchClick = (event) => {
        event.stopPropagation();
    };
    const handleItemClick = () => {
        if (disabled) {
            return undefined;
        }
        return onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    };
    return (<MenuItem disabled={disabled || loading} onClick={handleItemClick} closeOnClick={closeOnClick}>
      {children}
      {loading ? (<IconContainer>
          <Loader size="xs"/>
        </IconContainer>) : (<SwitchContainer data-checked={checked}>
          <Switch size="sm" checked={checked} disabled={disabled} onClick={handleSwitchClick} onCheckedChange={handleChange}/>
        </SwitchContainer>)}
    </MenuItem>);
}
